export default __webpack_public_path__ + "static/media/ic-email-template.a35d1e6f.svg";